export default __webpack_public_path__ + "static/media/ellipsis.7d8fe752.svg";